import React from "react";
import { Loader2 } from "lucide-react";

const VARIANTS = {
  primary: "bg-cp-accent text-white hover:bg-cp-accent-hover active:bg-[var(--cp-accent-active)] shadow-[var(--cp-shadow-sm)]",
  secondary: "bg-cp-surface text-cp-text border border-cp-border-strong hover:bg-cp-surface-hover hover:border-[#AEBAC8]",
  outline: "bg-cp-surface text-cp-accent border border-cp-accent-border hover:bg-cp-accent-soft hover:border-cp-accent",
  ghost: "text-cp-text-2 hover:bg-cp-surface-active hover:text-cp-text",
  amber: "bg-cp-amber text-white hover:bg-cp-amber-hover shadow-[var(--cp-shadow-sm)]",
  danger: "bg-cp-danger text-white hover:bg-cp-danger-hover shadow-[var(--cp-shadow-sm)]",
  "danger-soft": "bg-cp-danger-soft text-cp-danger border border-cp-danger-border hover:bg-[#FBDDD9]",
  success: "bg-cp-success text-white hover:bg-[#166F3C] shadow-[var(--cp-shadow-sm)]",
  link: "text-cp-accent hover:underline underline-offset-4 px-0 h-auto",
  dark: "bg-cp-navy text-white hover:bg-cp-navy-2",
  "on-dark": "bg-white/10 text-white border border-white/20 hover:bg-white/15",
};
const SIZES = {
  sm: "h-8 px-3 text-[13px] gap-1.5 [&_svg]:h-3.5 [&_svg]:w-3.5",
  md: "h-10 px-4 text-sm gap-2 [&_svg]:h-4 [&_svg]:w-4",
  lg: "h-[46px] px-5 text-[15px] gap-2 [&_svg]:h-4 [&_svg]:w-4",
  icon: "h-9 w-9 p-0 [&_svg]:h-4 [&_svg]:w-4",
  "icon-sm": "h-8 w-8 p-0 [&_svg]:h-4 [&_svg]:w-4",
};

export const Button = React.forwardRef(function Button(
  { variant = "primary", size = "md", loading = false, disabled, className = "", children, as: Comp = "button", ...rest }, ref
) {
  const isDisabled = disabled || loading;
  return (
    <Comp
      ref={ref}
      disabled={Comp === "button" ? isDisabled : undefined}
      aria-disabled={isDisabled || undefined}
      aria-busy={loading || undefined}
      className={`inline-flex items-center justify-center whitespace-nowrap font-medium rounded-[var(--cp-radius)] select-none
        transition-[background-color,border-color,color,transform,box-shadow] duration-150 ease-[var(--cp-ease)]
        active:scale-[0.985] disabled:pointer-events-none disabled:opacity-50 ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...rest}
    >
      {loading ? <Loader2 className="animate-spin" aria-hidden="true" /> : null}
      {children}
    </Comp>
  );
});

export default Button;
